<div class="main">
  <aku-header class="header"></aku-header>
  <div class="router-holder">
    <aku-start></aku-start>
    <router-outlet></router-outlet>
  </div>
  <aku-footer class="footer"></aku-footer>
</div>
<div [style.height.px]="1"></div>
